export class GoogleAdWords {
  private id: string
  private active: boolean
  private promise?: Promise<any>
  private dataLayerAdWords?: any

  constructor(id: string, active?: boolean) {
    this.id = id
    this.active = active!
  }

  public pageView(eventName: string, data: any) {
    return new Promise<void>((resolve, reject) => {
      this._load()
        .then(() => {
          this.gtag('config', this.id, {
            page_title: document.title,
            page_path: window.location.pathname,
          })
          resolve()
        })
        .catch(err => {
          console.error('Error loading Google Tag Manager')
          reject(err)
        })
    })
  }

  public track(eventName: string, data: any) {
    return new Promise((resolve, reject) => {
      this._load()
        .then(() => {
          const vars = {
            send_to: this.id + '/' + data.sendTo,
            ...data,
            event_callback: () => {
              resolve(data)
            },
          }
          this.gtag('event', 'conversion', vars)
        })
        .catch(err => {
          console.error('Error loading Google Tag Manager')
          reject(err)
        })
    })
  }

  private gtag(name: string, params: any, params2?: any) {
    this.dataLayerAdWords.push(arguments)
  }

  private _load() {
    return (
      this.promise ||
      (this.promise = new Promise<void>((resolve, reject) => {
        if (this.dataLayerAdWords) {
          resolve()
        } else {
          const script = document.createElement('script')

          script.onload = () => {
            this.dataLayerAdWords = (window as any).dataLayerAdWords =
              (window as any).dataLayerAdWords || []
            this.gtag('js', new Date())
            resolve()
          }

          script.onerror = error => {
            reject(error)
          }

          script.src = `https://www.googletagmanager.com/gtag/js?id=${this.id}&l=dataLayerAdWords`
          document.head.appendChild(script)
        }
      }))
    )
  }
}
